/* ============================================================
   PAPRIKA - ajustes de comportamento
   Ficheiro separado de proposito: uma atualizacao do tema nao
   apaga o que esta aqui.
   ============================================================ */

/* ------------------------------------------------------------
   Saltar para o topo certo de uma seccao
   Quando se chega a homepage com uma ancora no endereco
   (por exemplo /#shop-insta vindo do menu), o browser salta
   antes de as fotografias de cima terem altura. A pagina cresce
   a seguir e o salto fica a meio da seccao errada. Repetimos o
   salto depois de tudo carregar, ja com o cabecalho fixo
   descontado. Se a pessoa mexer na roda ou no ecra, deixamos de
   mexer: quem manda e ela.
   ------------------------------------------------------------ */
(function () {
  var cancelado = false;

  function cancelar() {
    cancelado = true;
  }

  function alturaDoCabecalho() {
    var cabecalho = document.querySelector('.site-header, .header, header');
    return cabecalho ? cabecalho.offsetHeight : 80;
  }

  function saltarParaAncora() {
    if (cancelado) return;

    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    var alvo;
    try {
      alvo = document.querySelector(hash);
    } catch (erro) {
      return;
    }
    if (!alvo) return;

    var destino =
      alvo.getBoundingClientRect().top +
      window.pageYOffset -
      alturaDoCabecalho() -
      20;

    window.scrollTo({ top: Math.max(destino, 0), behavior: 'auto' });
  }

  window.addEventListener('wheel', cancelar, { passive: true, once: true });
  window.addEventListener('touchstart', cancelar, { passive: true, once: true });
  window.addEventListener('keydown', cancelar, { once: true });

  window.addEventListener('load', function () {
    setTimeout(saltarParaAncora, 100);
    setTimeout(saltarParaAncora, 700);
  });
})();

/* ------------------------------------------------------------
   RESPOSTA IMEDIATA AO TOQUE
   O cliente e a designer relatam que no telemovel e preciso tocar
   mais do que uma vez. Enquanto nao fecharmos a causa, o site tem
   pelo menos de dizer que ouviu o toque.

   Serve tambem para diagnosticar, e e por isso que ficou assim:
   - se tocares e o botao NAO escurecer, o toque nunca chegou ao
     botao (ha alguma coisa por cima, ou o Safari comeu o toque);
   - se escurecer e a gaveta na mesma nao abrir, o toque chegou e o
     problema esta no que acontece a seguir.
   ------------------------------------------------------------ */
(function () {
  /* No iOS o estado :active so funciona se existir um ouvinte de
     toque registado. Este nao faz nada: existe so para o ligar. */
  document.addEventListener('touchstart', function () {}, { passive: true });

  var ALVOS = '.btn, drawer-opener button, .site-header a, .f-site-nav__link, .site-logo a';

  document.addEventListener(
    'pointerdown',
    function (evento) {
      var alvo = evento.target.closest && evento.target.closest(ALVOS);
      if (!alvo) return;
      alvo.classList.add('pk-tocado');
      setTimeout(function () {
        alvo.classList.remove('pk-tocado');
      }, 450);
    },
    { passive: true }
  );

  /* Botoes que abrem gavetas (filtros, menu, carrinho): se ao fim de
     um quarto de segundo ainda nao abriu, mostra que esta a tratar. */
  function porAEsperar(botao) {
    if (botao.querySelector('.pk-spinner')) return;
    var s = document.createElement('span');
    s.className = 'pk-spinner';
    s.setAttribute('aria-hidden', 'true');
    botao.appendChild(s);
    botao.classList.add('pk-aguarda');
    botao.setAttribute('aria-busy', 'true');
  }

  function limpar(botao) {
    botao.classList.remove('pk-aguarda');
    botao.removeAttribute('aria-busy');
    var s = botao.querySelector('.pk-spinner');
    if (s) s.remove();
  }

  document.addEventListener(
    'pointerdown',
    function (evento) {
      var opener = evento.target.closest && evento.target.closest('drawer-opener');
      if (!opener) return;
      var botao = opener.querySelector('button');
      if (!botao) return;

      var gaveta = opener.dataset.drawer
        ? document.querySelector(opener.dataset.drawer)
        : null;

      var relogio = setTimeout(function () {
        if (!gaveta || !gaveta.hasAttribute('open')) porAEsperar(botao);
      }, 250);

      var parar = function () {
        clearTimeout(relogio);
        limpar(botao);
      };

      if (gaveta) gaveta.addEventListener('open', parar, { once: true });
      setTimeout(parar, 4000); /* seguranca: nunca fica preso a rodar */
    },
    { passive: true }
  );
})();

/* ------------------------------------------------------------
   ABRIR AS GAVETAS AO LEVANTAR O DEDO
   Medimos que o botao de filtros SALTA 25px alguns segundos
   depois de a pagina abrir, enquanto as fotografias ainda estao
   a entrar. Se o dedo pousa no botao e o botao se mexe antes de
   o dedo levantar, o Safari conclui que foi um arrastar e NAO
   dispara o clique. O toque chegou (via-se o rodopio), mas a
   gaveta nunca recebia ordem para abrir.

   Aqui abrimos no levantar do dedo, desde que tenha sido mesmo
   um toque: pouco movimento e pouco tempo. Nao substitui o
   clique do tema, acrescenta-se a ele; se o clique vier a
   seguir, encontra a gaveta ja aberta e nao faz nada.
   So actua em ecras de toque.
   ------------------------------------------------------------ */
(function () {
  if (!window.matchMedia('(hover: none), (pointer: coarse)').matches) return;

  var TOLERANCIA_PX = 14;
  var TOLERANCIA_MS = 800;
  var inicio = null;

  document.addEventListener(
    'pointerdown',
    function (e) {
      var opener = e.target.closest && e.target.closest('drawer-opener');
      inicio = opener
        ? { opener: opener, x: e.clientX, y: e.clientY, t: Date.now() }
        : null;
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerup',
    function (e) {
      var d = inicio;
      inicio = null;
      if (!d) return;
      if (Math.abs(e.clientX - d.x) > TOLERANCIA_PX) return;
      if (Math.abs(e.clientY - d.y) > TOLERANCIA_PX) return;
      if (Date.now() - d.t > TOLERANCIA_MS) return;

      var alvo = d.opener.dataset.drawer;
      var gaveta = alvo ? document.querySelector(alvo) : null;
      if (!gaveta || gaveta.hasAttribute('open')) return;
      if (typeof gaveta.openDrawer !== 'function') return;

      gaveta.openDrawer(d.opener.querySelector('button') || d.opener);
    },
    { passive: true }
  );

  document.addEventListener('pointercancel', function () { inicio = null; }, { passive: true });
})();

/* ------------------------------------------------------------
   20. Marcar a fotografia da cor escolhida.

   Paprika, 6 de Outubro de 2026.

   Na pagina de produto as fotografias aparecem todas ao mesmo
   tempo, em grelha de duas colunas. Ao escolher uma cor o tema
   rola a pagina ate a fotografia dessa cor, mas nao deixa
   nenhuma marca: quem esta a olhar para seis fotografias nao
   percebe qual delas e a cor que acabou de escolher.

   Passamos a por uma moldura na fotografia da cor escolhida.

   Como se sabe qual e: a ficha do produto (#ProductData) traz,
   por variante, a fotografia que lhe esta atribuida. Esse numero
   e o mesmo que cada fotografia da galeria tem em data-media-id.
   Lemos as opcoes escolhidas directamente dos botoes, por isso
   nao dependemos de o tema ja ter actualizado o formulario.

   Nao marca nada quando so uma cor tem fotografia propria: ai a
   moldura nao distinguia coisa nenhuma.
   ------------------------------------------------------------ */
(function () {
  var CLASSE = 'pk-foto-da-cor';

  function fichaDoProduto(info) {
    if (info.__pkFicha !== undefined) return info.__pkFicha;
    var el = info.querySelector('#ProductData[type="application/json"]');
    try {
      info.__pkFicha = el ? JSON.parse(el.textContent) : null;
    } catch (e) {
      info.__pkFicha = null;
    }
    return info.__pkFicha;
  }

  function opcoesEscolhidas(info) {
    var campos = info.querySelectorAll('.variant-picker__field');
    if (!campos.length) return null;
    var escolhas = [];
    for (var i = 0; i < campos.length; i++) {
      var lista = campos[i].querySelector('select');
      if (lista) {
        escolhas.push(lista.value);
        continue;
      }
      var botao = campos[i].querySelector('input[type="radio"]:checked');
      if (!botao) return null;
      escolhas.push(botao.value);
    }
    return escolhas;
  }

  function varianteEscolhida(ficha, escolhas) {
    for (var i = 0; i < ficha.variants.length; i++) {
      var v = ficha.variants[i];
      if (!v.options || v.options.length !== escolhas.length) continue;
      var igual = true;
      for (var j = 0; j < escolhas.length; j++) {
        if (v.options[j] !== escolhas[j]) { igual = false; break; }
      }
      if (igual) return v;
    }
    return null;
  }

  function valeAPena(ficha) {
    var vistas = {};
    var quantas = 0;
    for (var i = 0; i < ficha.variants.length; i++) {
      var fm = ficha.variants[i].featured_media;
      if (fm && !vistas[fm.id]) { vistas[fm.id] = true; quantas++; }
    }
    return quantas > 1;
  }

  function marcar(info) {
    var galeria = info.querySelector('.f-product__media-list');
    if (!galeria) return;

    var antigas = galeria.querySelectorAll('.' + CLASSE);
    for (var i = 0; i < antigas.length; i++) antigas[i].classList.remove(CLASSE);

    var ficha = fichaDoProduto(info);
    if (!ficha || !ficha.variants || !valeAPena(ficha)) return;

    var escolhas = opcoesEscolhidas(info);
    if (!escolhas) return;

    var variante = varianteEscolhida(ficha, escolhas);
    if (!variante || !variante.featured_media) return;

    var foto = galeria.querySelector('[data-media-id="' + variante.featured_media.id + '"]');
    if (foto) foto.classList.add(CLASSE);
  }

  function marcarTodos() {
    var infos = document.querySelectorAll('product-info');
    for (var i = 0; i < infos.length; i++) marcar(infos[i]);
  }

  document.addEventListener('change', function (e) {
    var info = e.target.closest && e.target.closest('product-info');
    if (info) marcar(info);
  });

  /* o tema avisa quando a galeria acaba de se montar, e volta a
     avisar se a refizer */
  document.addEventListener('product-media:loaded', function (e) {
    var info = e.target.closest && e.target.closest('product-info');
    if (info) marcar(info);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', marcarTodos);
  } else {
    marcarTodos();
  }
})();
